import React from 'react'
import { Typography } from '@mui/material'
import Confetti from 'react-confetti'
import { useTranslation } from 'react-i18next'

interface CelebrationScreenProps {
  message: string
}

const CelebrationScreen: React.FC<CelebrationScreenProps> = ({ message }) => {
  const { t } = useTranslation()
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-white"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <Confetti />
      <Typography variant="h4" className="text-center mb-4">
        🎉 {message} 🎉
      </Typography>
      <Typography variant="subtitle1" className="text-center">
        {t('celebration.redirecting')}
      </Typography>
    </div>
  )
}

export default CelebrationScreen
